import { List, Skeleton } from "@mui/material"
import { whereSummary } from "routes/regime/plugins/zero-u-wizard/controller/where-summary"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { usePlanRoot } from "lib/use-plan-root"
import { Repeat } from "lib/@components/repeat"
import { LocationSummary } from "routes/regime/plugins/zero-u-wizard/location-summary"

export function AssetInfo({ task, skill, schedule, frequencyPeriod, frequencyInterval, minutes }) {
    const { parentItem } = useBoundContext()
    const planRoot = usePlanRoot()
    if (schedule === "-") schedule = undefined
    if (skill === "-") skill = undefined
    const filters = [
        { "task.title": task },
        skill && { skill: skill },
        schedule && { "schedule._id": schedule },
        frequencyPeriod !== undefined && { "frequency.period": frequencyPeriod },
        frequencyInterval !== undefined && { "frequency.interval": frequencyInterval },
        minutes !== undefined && { minutes: minutes },
    ].filter(Boolean)
    const assets = whereSummary.useResults(planRoot.id, parentItem.id, filters)

    return assets ? (
        <List dense sx={{ maxHeight: "50vh", overflowY: "auto" }}>
            <Repeat list={assets.summarise.summary} item={<LocationSummary />} />
        </List>
    ) : (
        <Skeleton height={40} width={100} />
    )
}
